import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { fetchPlayerUsers, usersSelector } from 'reducers/users';
import { RequestStateHelper } from 'reducers/createRequestReducer';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import FullWidthLoader from 'ui/base/FullWidthLoader';
import { playersSelector } from 'reducers/players';
import ExitCareCircleButton from '../players/ExitCareCircleButton';
import { LocaleConsumer } from 'containers/locale/LocaleProvider';

const styles = {
    userItem: {
        marginBottom: '6px',
    },
};

class PlayerUsersList extends React.Component {
    /**
     * Component state
     */
    state = {};

    /**
     * Constructor
     * @param props
     */
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.fetchPlayerUsers(this.props.playerId);
    }

    renderList() {
        const { classes, users, player, currentUser } = this.props;

        if (users.length === 1) {
            return <LocaleConsumer>{({ getTranslation }) => <Typography>{getTranslation('player_users_list_empty')}</Typography>}</LocaleConsumer>;
        }

        return (
            <div>
                <ul>
                    {users
                        .filter(user => user.id !== player.main_user_id)
                        .map(user => (
                            <li key={user.id} className={classes.userItem}>
                                <div>
                                    <Typography style={{ fontStyle: user.display_name.length ? 'normal' : 'italic' }}>
                                        {user.display_name.length ? `${user.display_name} (${user.email})` : `${user.email}`}
                                    </Typography>
                                    {player.main_user_id === currentUser.id && (
                                        <ExitCareCircleButton user={user} player={player} />
                                    )}
                                </div>
                            </li>
                        ))}
                </ul>
            </div>
        );
    }

    /**
     * Render component
     */
    render() {
        const { classes, isLoading } = this.props;

        return (
            <div>
                {isLoading && <FullWidthLoader />}
                {!isLoading && this.renderList()}
            </div>
        );
    }

    /**
     * Properties initilization
     */
    static propTypes = {
        playerId: PropTypes.number.isRequired,
    };
    static defaultProps = {};
}

const mapStateToProps = (state, ownProps) => {
    const usersState = usersSelector.getCurrentPlayerUsersState(state);
    return {
        users: usersSelector.getCurrentPlayerUsers(state),
        player: playersSelector.getPlayer(state, ownProps.playerId),
        currentUser: usersSelector.getCurrentUser(state),
        isLoading: RequestStateHelper.isLoading(usersState),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPlayerUsers: (playerId) => {
            dispatch(fetchPlayerUsers(playerId));
        },
    };
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PlayerUsersList));
